if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.errorElement = this.querySelector('.js-cart-terms-error');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.policyVersion = this.dataset.policyVersion || '2026-08';
      this.pendingUpdate = Promise.resolve();

      this.submitHandler = this.handleSubmit.bind(this);
      this.changeHandler = this.handleChange.bind(this);

      this.form.addEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.addEventListener('change', this.changeHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.removeEventListener('change', this.changeHandler);
    }

    /**
     * Records or clears consent on the cart as the checkbox is toggled.
     * Requests are chained rather than fired independently, so rapid toggling
     * cannot land at Shopify out of order and leave the recorded state
     * disagreeing with the checkbox.
     * Failures are swallowed so a network problem never blocks checkout.
     */
    handleChange() {
      const accepted = this.cartTermsCheckbox.checked;
      const cartRoute = (window.theme && theme.routes && theme.routes.cart) ? theme.routes.cart : '/cart';

      if (accepted) this.hideError();

      const attributes = accepted
        ? {
            policy_accepted: 'yes',
            policy_accepted_at: new Date().toISOString(),
            policy_version: this.policyVersion
          }
        : {
            policy_accepted: '',
            policy_accepted_at: '',
            policy_version: ''
          };

      this.pendingUpdate = this.pendingUpdate
        .then(() => fetch(`${cartRoute}/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes })
        }))
        .catch(() => {
          // Intentionally silent. Consent recording is best-effort and must
          // never prevent a customer from completing a purchase.
        });
    }

    /**
     * Shows the inline validation message.
     * Falls back to alert() if the error element is missing, so a surface
     * without the markup still blocks checkout visibly rather than silently.
     */
    showError() {
      if (!this.errorElement) {
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
        return;
      }

      this.errorElement.textContent = theme.strings.cartTermsConfirmation;
      this.errorElement.hidden = false;
      this.cartTermsCheckbox.setAttribute('aria-invalid', 'true');
      this.errorElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /**
     * Clears the inline validation message.
     */
    hideError() {
      if (!this.errorElement) return;

      this.errorElement.hidden = true;
      this.errorElement.textContent = '';
      this.cartTermsCheckbox.removeAttribute('aria-invalid');
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        this.showError();
      } else {
        this.hideError();
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}